var _title, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "22 7 45 45",
    role: "img",
    "aria-label": "[title]"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Linked In")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c8c8c8",
    d: "M59.4 11.6H29.6c-.7 0-1.3.3-1.8.7-.5.5-.8 1.1-.8 1.8v30c0 1.4 1.1 2.5 2.6 2.5h29.8c.7 0 1.3-.3 1.8-.7s.8-1.1.8-1.8v-30a2.6 2.6 0 00-2.6-2.5zm-22 29.8h-5.2V24.7h5.2v16.7zm-2.6-19l-1.1-.2-1-.7a2 2 0 01-.6-1c-.2-.4-.2-.8-.2-1.1l.2-1.1.6-1 1-.7c.4-.2.8-.2 1.1-.2.8 0 1.6.3 2.1.9.6.6.9 1.3.9 2.1s-.3 1.6-.9 2.1c-.6.6-1.3.9-2.1.9zm22 19h-5.1v-8.1c0-1.9 0-4.5-2.7-4.5s-3.1 2.1-3.1 4.3v8.3h-5.2V24.7h5V27h.1c.5-.9 1.2-1.6 2.1-2 .9-.5 1.8-.7 2.8-.7 5.2 0 6.2 3.5 6.2 8l-.1 9.1z"
  })));
};
export default SvgLinkedin;